import { render } from "./ModalEditionDepartement.vue?vue&type=template&id=09b58aa5"
import script from "./ModalEditionDepartement.vue?vue&type=script&lang=js"
export * from "./ModalEditionDepartement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__